/**
 * Pad a string to the specified length
 */
export function pad(str0, ch, len) {
    let str = str0 + '';
    while (str.length < len) {
        str = ch + str;
    }
    return str;
}
/** Type assert that a value is never */
export function assertNever(_val) {
    // Nothing to do
}
//# sourceMappingURL=Util.js.map